/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";

export interface DigestionPartForDigestionCreateRequest {
  locked?: boolean;
  workflowId?: string | null;
  workflowContext?: object | null;
  state?: ProcessState;
  sequence: number;
  context?: object | null;
  index?: Array<any> | null;
}

export function DigestionPartForDigestionCreateRequestFromJSON(
  json: any,
): DigestionPartForDigestionCreateRequest {
  return DigestionPartForDigestionCreateRequestFromJSONTyped(json);
}

export function DigestionPartForDigestionCreateRequestFromJSONTyped(
  json: any,
): DigestionPartForDigestionCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    workflowId: json["workflow_id"],
    workflowContext: json["workflow_context"],
    state:
      json["state"] === undefined
        ? undefined
        : ProcessStateFromJSON(json["state"]),
    sequence: json["sequence"],
    context: json["context"],
    index: json["index"],
  };
}

export function DigestionPartForDigestionCreateRequestToJSON(
  value: DigestionPartForDigestionCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    workflow_id: value.workflowId,
    workflow_context: value.workflowContext,
    state: ProcessStateToJSON(value.state),
    sequence: value.sequence,
    context: value.context,
    index: value.index,
  };
}
